import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldConfigureEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-configure-edit',
	path: '/secure/admin/EditDefaultFieldLayoutItem!default.jspa',
};
